import { Link } from 'react-router';

/**
 * Catch-all 404 page. Without this, an undefined route rendered a blank screen
 * (no matching <Route>). Mounted at `path="*"` inside the Layout.
 */
export function NotFoundPage(): React.JSX.Element {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-8 text-center">
      <p className="text-5xl font-semibold text-text-primary">404</p>
      <p className="text-text-secondary">This page doesn’t exist.</p>
      <Link
        to="/chat"
        className="mt-2 rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground hover:opacity-90"
      >
        Back to chat
      </Link>
    </div>
  );
}
